import CountdownClockWAC from "./macros/countdownClockWAC/countdownClockWAC";
import OurCars from "./macros/ourCars/ourCars";
import { withBotBGrid } from "../../../hoc/withBotBGrid";
import { OurCarsMacroProps } from "./types";
import Rte from "../../widgets/rte";
import MythIcons from "./mythIcons";
import OurInstantWin from "./macros/ourInstantWin/ourInstantWin";

const DreamCar = ({ controls }: OurCarsMacroProps) => {
  const renderMacro = (control: any) => {
    if (control !== null && control.editor !== null && control.editor.view !== null) {
      const view = control.editor.render ?? control.editor.view;
      if (view === "macro") {
        let macroParams;
        switch (control.value.macroAlias) {
          case "CountdownClockWAC":
            macroParams = control.value.macroParamsDictionary;
            return (
              <CountdownClockWAC
                title={macroParams["Title"]}
                description={macroParams["Description"]}
                competitionType={macroParams["CompetitionType"]}
              />
            );
          case "OurCars":
            macroParams = control.value.macroParamsDictionary;
            return <OurCars competitionTypeId={macroParams["CompetitionType"]} />;
          case "OurInstantWinPrizes":
            macroParams = control.value.macroParamsDictionary;
            return (
              <OurInstantWin
                competitionTypeId={macroParams["enterFromCompetitionPictureType"]}
                competitionId={macroParams["competitionId"]}
              />
            );
          case "MythIcons":
            return <MythIcons />;
        }
      } else {
        return <Rte xmlString={control.value} />;
      }
    }
  };

  return controls?.map((control: any, controlIndex: number) => <div key={controlIndex}>{renderMacro(control)}</div>);
};

export const DreamCarWithCompetition = withBotBGrid(DreamCar);
